import Vue from 'vue';

// Login
import LoginPage from './components/loginPage';
import signInWithGoogle from './components/signInWithGoogle';
import maintenance from './components/siteDown';

import switchClient from './components/switchClient';

// magicLink for mobile app login and get access token with token-link
import magicLink from './components/magicLink';

// Reset Password
import resetPassword from './components/resetPassword';
// Page not found
import pageNotFound from './components/pageNotFound';
// Jobs List
import JobList from './components/jobs/jobList';
// Jobs Details
import jobDetails from './components/jobs/jobDetails';
// review deleted jobs
import reviewDeletedJob from './components/jobs/reviewDeletedJob';
// Resume
import Resume from './components/resume/resume';
// Calls List
import CallList from './components/calls/callList';
// Employees
import EmployeeList from './components/employees/employeeList';
import EmployeeDetails from './components/employees/employeeDetails';
import addEmployeePersonal from './components/employees/addEmployeePersonal';
import addEmployee from './components/employees/addEmployee';
import editEmployee from './components/employees/editEmployee';
import deleteEmployee from './components/employees/deleteEmployee';
import vacationLog from './components/employees/vacationLog';
import addEmployeeNewFlow from './components/employees/addEmployeeNewFlow';
import clientEmployeeAssociation from './components/employees/clientEmployeeAssociation';

// Emplyers
import EmployerList from './components/employers/employerList';
import addEmployer from './components/employers/addEmployer';
import editEmployer from './components/employers/editEmployer';
import deleteEmployers from './components/employers/deleteEmployers';
import employerDetails from './components/employers/employerDetails';
// Skills
import Skills from './components/skills/viewSkills';
import archiveSkills from './components/skills/archiveSkills';
import rateTable from './components/skills/rateTable';
// Notify
import Notify from './components/notify';

import CsInvoices from './components/csInvoices';
import Employee911Availability from './components/Employee911Availability';
// Daily Schedule
import DailySchedule from './components/dailySchedule';
// Phonesheet
import PhoneSheet from './components/phoneSheet';
// Files
import Files from './components/files';

// Calls
// import bulkAssign from './components/calls/bulkAssign';
// import bulkAssignCustom from './components/calls/bulkAssignCustom';
import bulkAssignCustom from './components/calls/assign/bulk';

// import singleAssign from './components/calls/singleAssign';
// import singleAssignCustom from './components/calls/singleAssignCustom';
import singleAssignCustom from './components/calls/assign/single';
// View Calls
import ViewCalls from './components/calls/viewCalls';
import addCall from './components/calls/addCall';

import jobAttendance from './components/calls/jobAttendance';
// Schedule
import Schedule from './components/schedule/schedule';
import scheduleWishlist from './components/schedule/wishlist';
import scheduleSmslog from './components/schedule/smslog';

import clientSMSLog from './components/clientSmsLog';
import actionLog from './components/schedule/actionlog';
//Sign in Sheet
import signinsheet from './components/schedule/signinsheet.vue';
import jobSheet from './components/jobs/signInSheet/clientSheet.vue';
// Profile
import myProfile from './components/userProfile/myProfile';
import stripeSuccess from './components/userProfile/stripeSuccess';

// authNylas
import authNylas from './components/userProfile/authNylas';

// Venue
import venueMain from './components/venue/venue';
import addVenue from './components/venue/addVenue';
// Report
import reportMain from './components/report/report';
import reportList from './components/report/reportList';
import newReportGlobal from './components/report/newRepotGlobal.vue';

// import activeReports from './components/report/activeReports';
// Configuration
import configurationMain from './components/configuration/configuration';
//calendar
import calendar from './components/calendar/calendar.vue';
import calendarJobCall from './components/calendar/calendarJobCall.vue';
// SUPER ADMIN
//client List
import clientList from './components/superAdmin/clientList.vue';
//add client
import addClient from './components/superAdmin/addClient.vue';
//edit client
import editClient from './components/superAdmin/editClient.vue';
//Send Notice
import clientSendNotice from './components/superAdmin/clientSendNotice.vue';
// Manage Exception
import manageExceptions from './components/superAdmin/manageExceptions.vue';
// Add Employee CSV
import addEmployeeCSV from './components/superAdmin/addEmployeeCSV.vue';

import adminConfig from './components/superAdmin/adminConfig.vue';

import ReportsConfig from './components/superAdmin/reportsConfig/ReportsConfig.vue';


//Employer from Super-Admin
import clientEmployersList from './components/superAdmin/employers/clientEmployersList.vue';
import addEmployerClient from './components/superAdmin/employers/addEmployerClient.vue';
import editEmployerClient from './components/superAdmin/employers/editEmployerClient.vue';
import employerDetailsClient from './components/superAdmin/employers/employerDetailsClient.vue';
import empoyerProfile from './components/employers/empoyerProfile';
import companyInfo from './components/employers/companyInfo';
import employerUserList from './components/employers/employerUserList';
import addEmployerUser from './components/employers/addEmployerUser';
import editEmployerUser from './components/employers/editEmployerUser';
import employerJobList from './components/jobs/employerJobList';
import employerJobDetails from './components/jobs/employerJobDetails';
import employerSignInSheet from './components/jobs/signInSheet/employerSignInSheet';
import viewCallsEmployer from './components/calls/employer/viewCalls';
import calendarEmployer from './components/calendar/calendarEmployer.vue';
import tinyUrl from './components/superAdmin/tinyUrl.vue';
import forceLogin from './components/forceLogin';

// super admin employee.
import superAdminEmployeeList from './components/superAdmin/employees/superAdminEmployeeList.vue';
import mergeEmployee from './components/superAdmin/employees/mergeEmployee.vue';

// Employee Merger Form
import employeeMergerForm from './components/superAdmin/mergers/employeeMergerForm.vue';

// Employer Merger Form
import employerMergerForm from './components/superAdmin/mergers/employerMergerForm.vue';



function cookie() {
    var cookie = document.cookie.split("=");
    return cookie[1];
}
export const superAdminRoute = [
    'LoginPage',
    'signInWithGoogle',
    'pageNotFound',
    //'JobList',
    //'jobDetails',
    //'EmployeeList',
    // 'EmployeeDetails',
    // 'addEmployee',
    // 'editEmployee',
    // 'employerDetails',
    // 'deleteEmployee',
    // 'EmployerList',
    // 'addEmployer',
    // 'editEmployer',
    // 'employerDetails',
    // 'deleteEmployers',
    // 'Skills',
    // 'archiveSkills',
    // 'rateTable',
    // 'Notify',
    // 'DailySchedule',
    // 'PhoneSheet',
    // 'Files',
    // 'bulkAssign',
    // 'singleAssign',
    // 'ViewCalls',
    // 'Schedule',
    // 'scheduleWishlist',
    // 'scheduleSmslog',
    // 'actionLog',
    // 'signinsheet',
    // 'myProfile',
    // 'venueMain',
    // 'reportMain',
    // 'reportList',
    // 'configurationMain',
    // 'calendar',
    // 'calendarJobCall',
    'jobReports',
    'clientList',
    'addClient',
    'editClient',
    'clientSendNotice',
    'manageExceptions',
    'addEmployeeCSV',
    'clientEmployersList',
    'addEmployerClient',
    'editEmployerClient',
    'employerDetailsClient',
    'tinyUrl',
    'adminConfig',
    'ReportsConfig',
    'adminEmployeeList',
    'forceLogin',
    'mergeEmployee',
    'employeeMergerForm',
    'employerMergerForm'
];
export const clientAdminRoute = [
    'LoginPage',
    'signInWithGoogle',
    'pageNotFound',
    'JobList',
    'jobDetails',
    'reviewDeletedJob',
    'EmployeeList',
    'EmployeeDetails',
    'addEmployee',
    'editEmployee',
    'employerDetails',
    'deleteEmployee',
    'EmployerList',
    'addEmployer',
    'editEmployer',
    'editEmployerClient',
    'employerDetails',
    'deleteEmployers',
    'vacationLog',
    'Skills',
    'archiveSkills',
    'rateTable',
    'Notify',
    'DailySchedule',
    'PhoneSheet',
    'Files',
    // 'bulkAssign',
    'bulkAssignCustom',
    // 'singleAssign',
    'singleAssignCustom',
    'ViewCalls',
    'jobAttendance',
    'addCall',
    'Schedule',
    'scheduleWishlist',
    'scheduleSmslog',
    'actionLog',
    'signinsheet',
    'jobSheet',
    'myProfile',
    'stripeSuccess',
    "authNylas",
    'venueMain',
    'addVenue',
    'reportMain',
    'reportList',
    'jobReports',
    'configurationMain',
    'calendar',
    'calendarJobCall',
    // 'clientList',
    // 'addClient',
    // 'editClient',
    // 'clientSendNotice',
    // 'manageExceptions',
    'addEmployeeCSV',
    'viewCallsEmployer',
    'addEmployerClient',
    'switchClient',
    'clientEmployeeAssociation',
    'addEmployeeNewFlow',
    'forceLogin',
    'Resume',
    'new-report-list',
    'employeeMergerForm',
    'CallList',
    'clientSMSLog',
    'CsInvoices',
    'Employee911Availability'
];
export const userRoute = [
    'LoginPage',
    'signInWithGoogle',
    'pageNotFound',
    'JobList',
    'jobDetails',
    //'EmployeeList',
    //'EmployeeDetails',
    //'addEmployee',
    'editEmployee',
    //'employerDetails',
    //'deleteEmployee',
    //'EmployerList',
    //'addEmployer',
    //'editEmployer',
    //'employerDetails',
    //'deleteEmployers',
    //'Skills',
    //'archiveSkills',
    // 'rateTable',
    'Notify',
    //'DailySchedule',
    'PhoneSheet',
    //'Files',
    // 'bulkAssign',
    'bulkAssignCustom',
    // 'singleAssign',
    'singleAssignCustom',
    'ViewCalls',
    'jobAttendance',
    'addCall',
    'Schedule',
    'scheduleWishlist',
    'scheduleSmslog',
    'actionLog',
    'signinsheet',
    'jobSheet',
    'myProfile',
    'stripeSuccess',
    'authNylas',
    'vacationLog',
    //'venueMain',
    'reportMain',
    'reportList',
    'jobReports',
    //'configurationMain',
    'calendar',
    'calendarJobCall',
    // 'clientList',
    // 'addClient',
    // 'editClient',
    // 'clientSendNotice',
    // 'manageExceptions',
    // 'addEmployeeCSV',
    'switchClient',
    'forceLogin',
    'Resume',
    'new-report-list',
    // 'CallList',
    // 'CsInvoices'
];
export const employerAdminRoute = [
    'addCall',
    'employerJobList',
    'venueMain',
    'empoyerProfile',
    'companyInfo',
    'employerUserList',
    'addEmployerUser',
    'editEmployerUser',
    'editEmployerClient',
    'employerJobDetails',
    'viewCallsEmployer',
    'calendarEmployer',
    'calendarJobCall',
    'employerSignInSheet',
    'forceLogin',
];
export const employerRoute = [
    'addCall',
    'employerJobList',
    'venueMain',
    'empoyerProfile',
    'companyInfo',
    // 'employerUserList',
    // 'addEmployerUser',
    'editEmployerUser',
    'employerJobDetails',
    'viewCallsEmployer',
    'calendarEmployer',
    'calendarJobCall',
    'employerSignInSheet',
    'forceLogin'
];
export const publicRoutes = [
    'LoginPage',
    'signInWithGoogle',
    'forceLogin',
    'pageNotFound',
    'resetPassword',
    'jobReports',
    'maintenance',
    'magicLink'
];

export const routes = [
    // Login
    {
        path: '/login',
        name: 'LoginPage',
        component: LoginPage
    },
    {
        path: '/sign-in-with-google',
        name: 'signInWithGoogle',
        component: signInWithGoogle
    },
    // {
    //     path: '/login',
    //     name: 'LoginPage',
    //     component: maintenance
    // },
    {
        path: '/login/:type/:id/:token',
        name: 'forceLogin',
        component: forceLogin
    },
    {
        path: '/switchClient',
        name: 'switchClient',
        component: switchClient
    },
    // pageNotFound
    {
        path: '/pageNotFound',
        name: 'pageNotFound',
        component: pageNotFound
    },
    // Reset Password
    {
        path: '/resetPassword/:id',
        name: 'resetPassword',
        component: resetPassword
    },
    {
        path: '/magic-link',
        name: 'magicLink',
        component: magicLink
    },
    // Job List
    {
        path: '/jobList',
        name: 'JobList',
        component: JobList,
        meta: { title: 'Jobs/Events' } 
    },
    // Call List
    {
        path: '/callList11',
        name: 'CallList',
        component: CallList,
    },
    // reviewDeletedJob
    {
        path: '/review-job/:jobId',
        name: 'reviewDeletedJob',
        component: reviewDeletedJob,
    },
    // Job Details
    {
        path: '/jobDetails/:id',
        name: 'jobDetails',
        component: jobDetails,
    },
    // Resume
    {
        path: '/resume',
        name: 'Resume',
        component: Resume
    },
    // Employees
    {
        path: '/employees',
        name: 'EmployeeList',
        component: EmployeeList
    },
    {
        path: '/employeeDetails/:employeeId',
        name: 'EmployeeDetails',
        component: EmployeeDetails
    },
    {
        path: '/addEmployee',
        name: 'addEmployee',
        component: addEmployee
    },
    {
        path: '/editEmployee/:empId',
        name: 'editEmployee',
        component: editEmployee
    },
    {
        path: '/deleteEmployee',
        name: 'deleteEmployee',
        component: deleteEmployee
    },
    {
        path: '/vacationLog/:empId',
        name: 'vacationLog',
        component: vacationLog
    },
    {
        path: '/clientEmployeeAssociation',
        name: 'clientEmployeeAssociation',
        component: clientEmployeeAssociation
    },
    {
        path: '/add-new-employee',
        name: 'addEmployeeNewFlow',
        component: addEmployeeNewFlow
    },
    // Emplyers
    {
        path: '/employerList',
        name: 'EmployerList',
        component: EmployerList

    },
    {
        path: '/addEmployer',
        name: 'addEmployer',
        component: addEmployer
    },
    {
        path: '/editEmployer',
        name: 'editEmployer',
        component: editEmployer
    },
    {
        path: '/employerDetails/:employerId',
        name: 'employerDetails',
        component: employerDetails
    },
    {
        path: '/deleteEmployers',
        name: 'deleteEmployers',
        component: deleteEmployers
    },
    // Skills
    {
        path: '/skills',
        name: 'Skills',
        component: Skills
    },
    {
        path: '/archiveSkills',
        name: 'archiveSkills',
        component: archiveSkills
    },
    {
        path: '/rateTable',
        name: 'rateTable',
        component: rateTable
    },
    // Notify
    {
        path: '/notify',
        name: 'Notify',
        component: Notify
    },
    // cs-invoices
    {
        path: '/cs-invoices',
        name: 'CsInvoices',
        component: CsInvoices
    },
    {
        path: '/911-availability',
        name: 'Employee911Availability',
        component: Employee911Availability
    },
    // Daily Schedule
    {
        path: '/dailySchedule',
        name: 'DailySchedule',
        component: DailySchedule
    },
    // Phonesheet
    {
        path: '/phoneSheet/:jobId',
        name: 'PhoneSheet',
        component: PhoneSheet
    },
    // Files
    {
        path: '/files',
        name: 'Files',
        component: Files
    },
    // Calls
    //    {
    //        path: '/bulkAssign/:id',
    //        name: 'bulkAssign',
    //        component: bulkAssign
    // },
    {
        path: '/bulkAssignCustom/:id',
        name: 'bulkAssignCustom',
        component: bulkAssignCustom
    },
    //    {
    //        path: '/singleAssign/:id',
    //        name: 'singleAssign',
    //        component: singleAssign
    // },
    {
        path: '/singleAssignCustom/:id',
        name: 'singleAssignCustom',
        component: singleAssignCustom
    },  
    // View Calls
    {
        path: '/viewCalls/:jobId',
        name: 'ViewCalls',
        component: ViewCalls
    },
    {
        path: '/addCall/:id',
        name: 'addCall',
        component: addCall
    },
    // 'jobAttendance',
    {
        path: '/jobAttendance/:jobId',
        name: 'jobAttendance',
        component: jobAttendance
    },
    // Schedule
    {
        path: '/schedule/:empId',
        name: 'Schedule',
        component: Schedule,
    },
    {
        path: '/wishlist/:empId',
        name: 'scheduleWishlist',
        component: scheduleWishlist,
    },
    {
        path: '/notifyLog/:empId',
        name: 'scheduleSmslog',
        component: scheduleSmslog,
    },
    {
        path: '/clientSmsLog',
        name: 'clientSMSLog',
        component: clientSMSLog,
    },
    {
        path: '/actionlog/:empId',
        name: 'actionLog',
        component: actionLog,
    },
    //Sign in Sheet
    {
        path: '/signinsheet/:jobId',
        name: 'signinsheet',
        component: signinsheet,
    },
    // {
    //     path: '/jobReports/:url',
    //     name: 'jobReports',
    //     component: activeReports
    // },
    // {
    //     path: '/employeeReport/:url',
    //     name: 'jobReports',
    //     component: activeReports
    // },
    // {
    //     path: '/job-report',
    //     name: 'job-report',
    //     component: activeReports
    // },
    {
        path: '/jobSheet/:id',
        name: 'jobSheet',
        component: jobSheet,
    },

    // Profile
    {
        path: '/myProfile',
        name: 'myProfile',
        component: myProfile
    },
    {
        path: '/stripe-success',
        name: 'stripeSuccess',
        component: stripeSuccess
    },
    // auth Nylas
    {
        path: '/authNylas',
        name: 'authNylas',
        component: authNylas
    },
    // Venue

    {
        path: '/venue',
        name: 'venueMain',
        component: venueMain
    },
    {
        path: '/addVenue',
        name: 'addVenue',
        component: addVenue
    },
    // Report
    {
        path: '/report/:id',
        name: 'reportMain',
        component: reportMain
    },
    // Report List
    {
        path: '/reportList',
        name: 'reportList',
        component: reportList
    },
    {
        path: '/new-report-list',
        name: 'new-report-list',
        component: newReportGlobal
    },
    // Configuration
    {
        path: '/configuration',
        name: 'configurationMain',
        component: configurationMain
    },
    //calendar
    {
        path: '/calendar',
        name: 'calendar',
        component: calendar
    },
    //calendarJobCall
    {
        path: '/calendarJobCall/:jobId',
        name: 'calendarJobCall',
        component: calendarJobCall
    },
    //client list
    {
        path: '/clientList',
        name: 'clientList',
        component: clientList,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    //add client
    {
        path: '/addClient',
        name: 'addClient',
        component: addClient,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    //edit client
    {
        path: '/editClient',
        name: 'editClient',
        component: editClient,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    //Send Notice
    {
        path: '/clientSendNotice',
        name: 'clientSendNotice',
        component: clientSendNotice,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    // Manage Exception
    {
        path: '/manageExceptions',
        name: 'manageExceptions',
        component: manageExceptions,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    // Add Employee CSV
    {
        path: '/addEmployeeCSV',
        name: 'addEmployeeCSV',
        component: addEmployeeCSV,
        // beforeEnter: (to, from, next) => {
        //     if (cookie() == 'super-admin')
        //         next();
        //     else
        //         next('/login');
        // }
    },
    {
        path: '/adminConfig',
        name: 'adminConfig',
        component: adminConfig
    },

    {
        path: '/admin-reports-configuration',
        name: 'ReportsConfig',
        component: ReportsConfig
    },

    //client Employers List
    {
        path: '/clientEmployersList',
        name: 'clientEmployersList',
        component: clientEmployersList,
    },
    // Add Employer Client
    {
        path: '/addEmployerClient',
        name: 'addEmployerClient',
        component: addEmployerClient,
    },
    // Edit Employer Client
    {
        path: '/editEmployerClient/:id',
        name: 'editEmployerClient',
        component: editEmployerClient,
    },
    //
    {
        path: '/employerDetailsClient/:id',
        name: 'employerDetailsClient',
        component: employerDetailsClient,
    },
    {
        path: '/employerJobList',
        name: 'employerJobList',
        component: employerJobList,
    },
    {
        path: '/employerSignInSheet/:jobId',
        name: 'employerSignInSheet',
        component: employerSignInSheet,
    },
    {
        path: '/empoyerProfile/:id',
        name: 'empoyerProfile',
        component: empoyerProfile,
    },
    {
        path: '/companyInfo',
        name: 'companyInfo',
        component: companyInfo,
    },
    {
        path: '/employerUserList',
        name: 'employerUserList',
        component: employerUserList,
    },
    {
        path: '/addEmployerUser',
        name: 'addEmployerUser',
        component: addEmployerUser,
    },
    {
        path: '/editEmployerUser/:id',
        name: 'editEmployerUser',
        component: editEmployerUser,
    },
    {
        path: '/employerJobDetails/:id',
        name: 'employerJobDetails',
        component: employerJobDetails,
    },
    {
        path: '/viewCallsEmployer/:jobId',
        name: 'viewCallsEmployer',
        component: viewCallsEmployer,
    },
    {
        path: '/calendarEmployer',
        name: 'calendarEmployer',
        component: calendarEmployer,
    },
    {
        path: '/tinyUrl',
        name: 'tinyUrl',
        component: tinyUrl,
    },
    {
        path: '/adminEmployeeList',
        name: 'adminEmployeeList',
        component: superAdminEmployeeList,
    },
    {
        path: '/mergeEmployee',
        name: 'mergeEmployee',
        component: mergeEmployee,
    },
    {
        path: '/employeeMergerForm',
        name: 'employeeMergerForm',
        component: employeeMergerForm,
    },
    {
        path: '/employerMergerForm',
        name: 'employerMergerForm',
        component: employerMergerForm,
    },
];





// WEBPACK FOOTER //
// ./src/routes.js